import { z } from 'zod';

/**
 * Einheitlicher Teilnehmerstatus — aggregiert aus mehreren Quellen.
 * Priority: checked_in > cancelled > ticket_sent > registered > preliminary > no_show
 */
export const ParticipantStatusSchema = z.enum([
  'checked_in',
  'cancelled',
  'ticket_sent',
  'registered',
  'preliminary',
  'no_show',
]);

/** TypeScript Type für Teilnehmerstatus */
export type ParticipantStatus = z.infer<typeof ParticipantStatusSchema>;

/**
 * Zod Schema für ParticipantView — Runtime-Validierung + Type-Inference.
 * Einheitliche Sicht auf alle Teilnehmer eines Events, unabhängig von der Quelle.
 * Aggregiert Daten aus EventRegistration, Reservation, Ticket, CheckIn und Waitlist.
 */
export const ParticipantViewSchema = z.object({
  userId: z.string(),
  email: z.string().email(),
  displayName: z.string().nullable().optional(),
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  avatarUrl: z.string().nullable().optional(),
  status: ParticipantStatusSchema,
  source: z.string().nullable().optional(),
  companions: z.number().int().nonnegative(),
  ticketCount: z.number().int().nonnegative(),
  hasCheckedIn: z.boolean(),
  registeredAt: z.coerce.date(),
  cancelledAt: z.coerce.date().nullable().optional(),
});

/** TypeScript Type — abgeleitet aus dem Zod Schema */
export type ParticipantView = z.infer<typeof ParticipantViewSchema>;
